<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-01 17:29:07
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-01 17:29:07
-->
<template>
  <div class="news">

    <div class="title-box">
      <h1>{{ data.name }}</h1>
    </div>

    <div class="content">
      <!-- 富文本方式 -->
      <div v-html="data.content"></div>

      <div v-if="imgsfiles && imgsfiles.length" class="download">
        <div>附件：</div>
        <div class="file-list">
          <a
            v-for="item in imgsfiles"
            :key="item.id"
            :href="item"
            >{{ item.originalFileName }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "../util/request";
export default {
  data() {
    return {
      imgsfiles: [],
      html: "<div>123</div>",
      data: {},
      files: [
        { url: "https://www.baidu.com", name: "附件1" },
        { url: "213", name: "附件2" },
      ],
    };
  },
  mounted() {
    let code = this.$route.query.code;
    this.quertDetail(code);

  },
    // ...
  activated: function() {
     let code = this.$route.query.code;
    this.quertDetail(code);
  },
  methods: {
    quertDetail(code) {
      let url = "/api/client/common/singlepage/";
      request({
        url: url + code,
        method: "get",
      }).then((res) => {
         console.log( res);
        if (res.code == "200") {
          this.data = res.data;
          request({
            url: "/api/common/attachment/detail",
            method: "get",
            params: { ids: this.data.fileId },
          }).then((res) => {
            this.imgsfiles = res.data;
          });
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.news {
  .title-box {
    width: 1280px;
    height: 120px;
    margin: 20px auto;
    padding: 20px;
    justify-content: center;
    background: #fff;
    h1 {
      text-align: center;
    }
    .sub-title {
      margin: 20px auto;
      color: #999;
      width: 500px;
      display: flex;
      justify-content: space-around;
    }
  }
  .content {
    width: 1280px;
    margin: 20px auto;
    padding: 20px 100px;
    background: #fff;
  }
  .download {
    display: flex;
    .file-list {
      display: flex;
      flex-direction: column;
      a {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
